export const EMBED_ROUTES = {
  index: {
    path: 'embed/sensors/insights',
    to: '/embed/sensors/insights',
  },
}
